/** Main site script should go in this file. */

jQuery.fn.reverse = [].reverse;
var flickitySmall = false,
    flickityLarge = false;

jQuery(document).ready(function() {
	
	// Set up SmartMenus
	setupNav();
	
	// Update the cart text via ajax
	getCartText();

	// Vote form (upcoming projects, build reports)
	jQuery('.afx-vote-btn').on('click', voteBtnHandler);

	// Vote form (kit requests)
	jQuery('.afx-product-vote-btn').on('click', requestKitBtnHandler);

	// Email signup button
	jQuery('.afx-email-form').on('submit', subscribeBtnHandler);

	jQuery(window).breakpointEvents({
		defaultBreakpoint: 'xs',
		breakpoints: {
			'sm' : 540,
			'md' : 720,
			'lg' : 960,
			'xl' : 1140
		},
		modelSelector: '.container',
		debug: false
	});

	jQuery('.quick-links__heading__title').on('click', quickLinksExpand);

	// Smooth scroll to ID anchors
	jQuery('a[href^="#"]').click(function(e) {
		var target = this.hash;
		if (target && target != '') {
			e.preventDefault();
			jQuery('html, body').stop().animate({
				'scrollTop': jQuery(target).offset().top
			}, 750, 'swing');
		}
	});

});

jQuery(window).on('bp:xs bp:sm', function() {
	jQuery('.footer-collapse__heading').on('click', footerMenuExpand);
	var $accountNav        = jQuery('.woocommerce-MyAccount-navigation'),
		$accountNavHeading = jQuery('<div class="woocommerce-MyAccount-navigation__heading d-md-none">Account Navigation <span class="fas fa-caret-right"></span></div>');
	$accountNavHeading.prependTo($accountNav).on('click', accountNavExpand);
})
.on('bp:md bp:lg bp:xl', function() {
	jQuery('.footer-collapse__heading').off('click', footerMenuExpand);
	var $accountNavHeading = jQuery('.woocommerce-MyAccount-navigation__heading');
	if ($accountNavHeading.length) {
		$accountNavHeading.off('click', accountNavExpand).remove();
	}
})
.on('bp:xs bp:sm bp:md', mobilizeInteriorNav)
.on('bp:lg bp:xl', deMobilizeInteriorNav)
.on('bp:xs bp:sm bp:md bp:lg', function() {
	if (flickityLarge) {
		jQuery('.projects-carousel').flickity('destroy');
	}
	jQuery('.projects-carousel').flickity({
		cellAlign: 'center',
		imagesLoaded: true,
		pageDots: false,
		wrapAround: true
	});
	flickityLarge = false;
	flickitySmall = true;
})
.on('bp:xl', function() {
	if (flickitySmall) {
		jQuery('.projects-carousel').flickity('destroy');
	}
	jQuery('.projects-carousel').flickity({
		cellAlign: 'left',
		imagesLoaded: true,
		pageDots: false,
		wrapAround: false
	});
	flickitySmall = false;
	flickityLarge = true;

});

var footerMenuAnimating = false;
function footerMenuExpand(e) {

	e.preventDefault();

	// Cancel if there's another animation happening
	if (footerMenuAnimating) {
		return;
	}
	var $footerHeader    = jQuery(this),
		$footerMenuOuter = $footerHeader.closest('.footer-collapse__outer'),
		$footerMenu      = jQuery('.footer-collapse', $footerMenuOuter).first();

	if ($footerMenuOuter.hasClass('footer-collapse__outer--collapsed')) {
		footerMenuAnimating = true;
		// Get natural height
		$footerMenu.css('height', 'auto');
		var footerMenuHeight = $footerMenu.outerHeight();
		$footerMenu.css('height', 0);
		$footerMenuOuter.removeClass('footer-collapse__outer--collapsed');
		$footerMenu.animate({'height' : footerMenuHeight + 'px'}, 250, 'swing', function() {
			$footerMenu.css('height', '');
			footerMenuAnimating = false;
		});
	} else {
		footerMenuAnimating = true;
		$footerMenuOuter.addClass('footer-collapse__outer--collapsed');
		$footerMenu.css('height', 'auto').animate({'height': 0}, 250, 'swing', function() {
			$footerMenu.css('height', '');
			footerMenuAnimating = false;
		});
	}
}

var accountNavAnimating = false;
function accountNavExpand(e) {

	e.preventDefault();

	// Cancel if there's another animation happening
	if (accountNavAnimating) {
		return;
	}
	var $navHeading = jQuery(this),
		$navOuter   = $navHeading.closest('.woocommerce-MyAccount-navigation'),
		$navInner   = jQuery('ul', $navOuter);

	if ($navOuter.hasClass('woocommerce-MyAccount-navigation--expanded')) {
		accountNavAnimating = true;
		$navInner.css('height', 'auto').animate({'height': 0}, 250, 'swing', function() {
			$navInner.css('height', '');
			$navOuter.removeClass('woocommerce-MyAccount-navigation--expanded');
			accountNavAnimating = false;
		});
	} else {
		accountNavAnimating = true;
		// Get natural height
		$navInner.css('height', 'auto');
		var navMenuHeight = $navInner.outerHeight();
		$navInner.css('height', 0);
		$navOuter.addClass('woocommerce-MyAccount-navigation--expanded');
		$navInner.animate({'height' : navMenuHeight + 'px'}, 250, 'swing', function() {
			$navInner.css('height', '');
			accountNavAnimating = false;
		});
	}
}

var quickLinksAnimating = false;
function quickLinksExpand(e) {

	e.preventDefault();

	// Cancel if there's another animation happening
	if (quickLinksAnimating) {
		return;
	}
	var $quickLinksHeader = jQuery(this),
		$quickLinksOuter  = $quickLinksHeader.closest('.quick-links'),
		$quickLinks       = jQuery('.quick-links__main', $quickLinksOuter).first();

	if ($quickLinksOuter.hasClass('quick-links--collapsed')) {
		quickLinksAnimating = true;
		// Get natural height
		$quickLinks.css('height', 'auto');
		var quickLinksHeight = $quickLinks.outerHeight();
		$quickLinks.css('height', 0);
		$quickLinksOuter.removeClass('quick-links--collapsed');
		$quickLinks.animate({'height' : quickLinksHeight + 'px'}, 250, 'swing', function() {
			$quickLinks.css('height', '');
			quickLinksAnimating = false;
		});
	} else {
		quickLinksAnimating = true;
		$quickLinksOuter.addClass('quick-links--collapsed');
		$quickLinks.css('height', 'auto').animate({'height': 0}, 250, 'swing', function() {
			$quickLinks.css('height', '');
			quickLinksAnimating = false;
		});
	}
}

// Initialize main navigation menu and menu behaviors
function setupNav() {

	jQuery('#main-menu__items').smartmenus({
		subIndicatorsPos: 'append',
		subMenusMinWidth: '100%',
		bottomToTopSubMenus: false
	});

	// Menu behaviors 
	var $mainMenuState   = jQuery('#main-menu__state'),
		$mainMenuOverlay = jQuery('#main-menu-overlay');
	if ($mainMenuState.length) {
		$mainMenuState.change(function(e) {
			var $menu = jQuery('#main-menu__items');
			if (this.checked) {
				$menu.hide()
					.css('right', '-80%')
					.show()
					.animate({ right: '0%' }, 250, 'swing', function() { 
						$menu.css('display', ''); 
					});
				$mainMenuOverlay.show();
			} else {
				$menu.show()
					.css('right', '0')
					.animate({ right: "-80%" }, 250, 'swing', function() { 
						$menu.css('display', ''); 
					});
				$mainMenuOverlay.hide();
			}
		});
		// Hide mobile menu when window is unloaded 
		// (prevents the menu from being shown on refresh)
		jQuery(window).bind('beforeunload unload', function() {
			if ($mainMenuState[0].checked) {
				$mainMenuState[0].click();
			}
		});
	}
	$mainMenuOverlay.click(function(e) {
		$mainMenuState.prop('checked', false).change();
	});
}

function getCartText() {
	var $cart = jQuery('.cart__text');

	jQuery.ajax({
		type: 'POST',
		url: ajaxurl,
		data: {
			'action' : 'afx_cart_text'
		},
		dataType: 'json',
		encode: true
	}).done(function(data) {
		if (data.success) {
			$cart.html(data.cart_text);
		} else {
			console.log('Failed to update cart text');
		}
	});
}

// Click handler for vote button
function voteBtnHandler(e) {

	var $form    = jQuery(this).closest('.afx-vote-form'),
		$message = jQuery('.upcoming-item__message', $form),
		$btn     = jQuery('.afx-vote-btn', $form),
		$votes   = jQuery('.afx-votes', $form),
		formData = {
			'pid'    : jQuery('input[name="afx_vote_pid"]', $form).val(),
			'hash'   : jQuery('input[name="afx_vote_hash"]', $form).val(),
			'action' : 'afx_vote'
		}
	
	jQuery.ajax({
		type: 'POST',
		url: ajaxurl,
		data: formData,
		dataType: 'json',
		encode: true
	}).done(function(data) {
		if (data.success) {
			// Change the icon
			if (data.direction == 'up') {
				$btn.html('<span class="fas fa-heart fa-beat"></span>');
			} else {
				$btn.html('<span class="far fa-heart"></span>');
			}
			// Set the vote count
			if (data.votes == 0) {
				data.votes = 'Be the first to vote for this.';
			}
			$votes.html(data.votes);
		} else {
			if (data.error == 'invalid_request') {
				console.log('Vote failure (invalid request)');
			} else {
				console.log('Vote failure (unspecified)');
			}
		}
	});

	e.preventDefault();

};

// Slightly modified version of kit 
function requestKitBtnHandler(e) {

	var $form    = jQuery(this).closest('.afx-product-vote-form'),
		$message = jQuery('.product__message', $form),
		$btn     = jQuery('.afx-product-vote-btn', $form),
		$icon    = jQuery('.afx-product-vote-btn-icon', $btn),
		$votes   = jQuery('.product__message', $form),
		formData = {
			'pid'    : jQuery('input[name="afx_vote_pid"]', $form).val(),
			'hash'   : jQuery('input[name="afx_vote_hash"]', $form).val(),
			'action' : 'afx_vote'
		}

	$icon.html('<span class="fas fa-circle-notch fa-spin"></span>');
	
	jQuery.ajax({
		type: 'POST',
		url: ajaxurl,
		data: formData,
		dataType: 'json',
		encode: true
	}).done(function(data) {
		if (data.success) {
			// Change the icon
			if (data.direction == 'up') {
				$btn.html('<span class="afx-product-vote-btn-icon"><span class="fas fa-heart fa-beat"></span></span> Requested');
			} else {
				$btn.html('<span class="afx-product-vote-btn-icon"><span class="far fa-heart"></span></span> Request Kit');
			}
			// Set the vote count
			if (data.votes == 1) {
				$votes.removeClass('product__message--hidden').html('<span class="product__message__votes">1</span> person is interested.');
			} else if (data.votes > 1) {
				$votes.removeClass('product__message--hidden').html('<span class="product__message__votes">' + data.votes + '</span> people are interested.');
			} else {
				$votes.addClass('product__message--hidden');
			}
		} else {
			if (data.error == 'invalid_request') {
				console.log('Vote failure (invalid request)');
			} else {
				console.log('Vote failure (unspecified)');
			}
		}
	});

	e.preventDefault();

};


// Click handler for email subscription button
function subscribeBtnHandler(e) {

	var $form       = jQuery(this).closest('.afx-email-form'),
		$message    = jQuery('.afx_email_submission_message', $form),
		$emailInput = jQuery('input[name="afx_email_address"]', $form),
		$btn        = jQuery('.afx-email-btn', $form),
		formData    = {
			'email'  : $emailInput.val(),
			'hash'   : jQuery('input[name="afx_email_hash"]', $form).val(),
			'action' : 'afx_signup'
		};

	$btn.addClass('afx-email-btn--loading').attr('disabled', true);
	
	jQuery.ajax({
		type: 'POST',
		url: ajaxurl,
		data: formData,
		dataType: 'json',
		encode: true
	}).done(function(data) {
		if (data.success) {
			$btn.removeClass('afx-email-btn--loading').attr('disabled', false);
			$emailInput.val('');
			$message.removeClass('alert alert-danger').addClass('alert alert-info').html('You\'ve been added to our email list!');
		} else {
			$btn.removeClass('afx-email-btn--loading').attr('disabled', false);
			$emailInput.val('');
			$message.removeClass('alert alert-info').addClass('alert alert-danger').html('There was an error adding you to the email list. Please refresh the page and try again.');
		}
	});

	e.preventDefault();

};

// Hook from bp:xs, bp:sm, bp:md
function mobilizeInteriorNav() {
	// Verify the existence of a sidebar menu on this page.
	// Note that for pages, the sidebar menu can also be called `#secondary`,
	// in which case we do not want to transform into the mobile version since
	// it's basically a throwaway/placeholder menu.
	if (jQuery('#interior').length) {
		transformInteriorNav('dropdown');
	} else if (jQuery('#widgets').length) {
		transformWidgets('dropdown');
	}
}

// Hook from bp:lg, bp:xl
function deMobilizeInteriorNav() {
	if (jQuery('#interior').length) {
		transformInteriorNav('sidebar');
	} else if (jQuery('#widgets').length) {
		transformWidgets('sidebar');
	}
}


// Transform sidebar navigation into mobile dropdown and back.
function transformInteriorNav(type) {

	if (typeof type === 'undefined') {
		console.log('No transformation type specified.');
		return;
	}

	var $intMenu      = jQuery('#interior'),
		parentId      = $intMenu.parent().attr('id'),
		$sidenavTitle = jQuery('.sidenav__title', $intMenu);

	if (parentId == 'sidebar' && type == 'dropdown') {
		// Convert to dropdown-type
		$intMenu.appendTo('#sidenav__anchor').addClass('sidebar--dropdown');
		// Attach events to dropdown
		$sidenavTitle.on('click', interiorNavDropdown);
	} else if (parentId == 'sidenav__anchor' && type == 'sidebar') {
		// Convert to sidebar-style
		$intMenu.appendTo('#sidebar').removeClass('sidebar--dropdown');
		$sidenavTitle.off('click', interiorNavDropdown);
	}
}

// Click handler for mobile interior nav dropdown functionality
function interiorNavDropdown() {
	var $this  = jQuery(this),
		$menu  = $this.next('.sidenav__wrap'),
		$outer = $this.parent('.sidenav__outer');

	if (!$menu.length || !$outer.length) {
		return;
	}

	if ($outer.hasClass('expanded')) {
		$outer.removeClass('expanded');
		$menu.show().slideUp(250, function() { 
			$menu.css('display', ''); 
		});
	} else {
		$outer.addClass('expanded');
		$menu.hide().slideDown(250, function() { 
			$menu.css('display', ''); 
		});
	}
}

// Transform news widgets into mobile dropdown and back.

var mobileTransformed = false,
	desktopTransformed = false;

function transformWidgets(type) {

	if (typeof type === 'undefined') {
		console.log('No transformation type specified.');
		return;
	}

	var $widgetContainer = jQuery('#widgets'),
		parentId         = $widgetContainer.parent().attr('id'),
		$widgets         = jQuery('.widget', $widgetContainer);

	// Clear out any expanded states when going between breakpoints
	$widgets.removeClass('widget--expanded');

	if (type == 'dropdown' && mobileTransformed == false) { // Convert container to dropdown-type

		mobileTransformed = true;
		desktopTransformed = false;

		// If there's a #widgets_anchor on the page, move it there
		var $widgetsAnchor = jQuery('#widgets__anchor');
		if (parentId == 'sidebar' && $widgetsAnchor.length) {
			$widgetContainer.appendTo('#widgets__anchor');
		}
		// Attach events to dropdown
		$widgets.each(function() {
			var $this  = jQuery(this),
				$title = jQuery('.widget__title', $this),
				$inner = jQuery('.widget__inner', $this);
			if ($inner.length && !$this.hasClass('widget--no-convert')) {
				$this.addClass('widget--dropdown');
				$title.on('click', widgetDropdown);
			}
		});
	} else if (type == 'sidebar' && desktopTransformed == false) { // Convert container to sidebar-style

		desktopTransformed = true;
		mobileTransformed = false;

		// If it's currently inside #widgets_anchor, move it back to the sidebar
		var $widgetSidebar = jQuery('#sidebar');
		if (parentId == 'widgets__anchor' && $widgetSidebar.length) {
			$widgetContainer.appendTo('#sidebar');			
		}

		$widgets.each(function() {
			var $this  = jQuery(this),
				$title = jQuery('.widget__title', $this),
				$inner = jQuery('.widget__inner', $this);
			if ($inner.length && !$this.hasClass('widget--no-convert')) {
				$this.removeClass('widget--dropdown');
				$title.off('click', widgetDropdown);
			}
		});
	}
}

// Click handler for widget dropdown functionality
function widgetDropdown() {
	var $this   = jQuery(this), // .widget__title
		$widget = $this.parent(),
		$inner  = jQuery('.widget__inner', $widget);

	if (!$inner.length) {
		return;
	}

	if ($widget.hasClass('widget--expanded')) {
		$inner.stop().animate({'height' : 0 }, 250, function() {
			$widget.removeClass('widget--expanded');
			$inner.css('height', '');
		});
	} else {
		// Collapse all other dropdowns first...
		jQuery('.widget--expanded').removeClass('widget--expanded');
		// ...then expand this one
		$widget.addClass('widget--expanded');
		$inner.stop().css('height', 'auto');
		var height = $inner.outerHeight();
		$inner.css('height', 0).animate({ 'height' : height }, 250, function() {
			$inner.css('height', ''); 
		});
	}
}

// Utility function to move kit photos to a container based on the specified breakpoint.
function moveKitPhotos(bp) {
	if (typeof bp === 'undefined') {
		console.log('No destination specified.');
		return;
	}

	jQuery.each([1, 2, 3], function(i, seq) {
		var $image           = jQuery('.kit-image-' + seq),
			destinationClass = 'kit-image-' + seq + '-' + bp;
			$destination     = jQuery('.' + destinationClass);

		// Check that it's not already a child of the destination container
		if (!$image.parent().hasClass(destinationClass)) {
			$image.appendTo($destination);
		}
	});
}

// Utility function to move project photos (generic, not PCB) to a container based on the specified breakpoint.
function moveProductPhoto(bp) {
	if (typeof bp === 'undefined') {
		console.log('No destination specified.');
		return;
	}

	var $photo           = jQuery('.project__photo'),
		destinationClass = 'project__photo__outer--' + bp;
		$destination     = jQuery('.' + destinationClass);

	// Check that it's not already a child of the destination container
	if (!$photo.parent().hasClass(destinationClass)) {
		$photo.appendTo($destination);
	}
}

// Utility function to move build videos to a container based on the specified breakpoint.
function moveProductVideo(bp) {
	if (typeof bp === 'undefined') {
		console.log('No destination specified.');
		return;
	}

	var $video           = jQuery('.project__video'),
		destinationClass = 'project__video__outer--' + bp;
		$destination     = jQuery('.' + destinationClass);

	// Check that it's not already a child of the destination container
	if (!$video.parent().hasClass(destinationClass)) {
		$video.appendTo($destination);
	}
}

// Click handler for project documents dropdown functionality
function projectDocsDropdown(e) {
	var $this  = jQuery(this),
		$menu  = $this.next('.project__docs__inner'),
		$outer = $this.parent('.project__docs');

	if (!$menu.length || !$outer.length) {
		return;
	}

	if ($outer.hasClass('project__docs--expanded')) {
		$menu.show().slideUp(250, function() { 
			$menu.css('display', ''); 
			$outer.removeClass('project__docs--expanded');
		});
	} else {
		$outer.addClass('project__docs--expanded');
		$menu.hide().slideDown(250, function() { 
			$menu.css('display', ''); 
		});
	}

	e.preventDefault();
}

// Click handler for tiered pricing dropdown functionality
function projectTieredPricingDropdown(e) {
	var $this  = jQuery(this),
		$menu  = $this.next('.project__tiered_pricing__inner'),
		$outer = $this.parent('.project__tiered_pricing');

	if (!$menu.length || !$outer.length) {
		return;
	}

	if ($outer.hasClass('project__tiered_pricing--expanded')) {
		$menu.show().slideUp(250, function() { 
			$menu.css('display', ''); 
			$outer.removeClass('project__tiered_pricing--expanded');
		});
	} else {
		$outer.addClass('project__tiered_pricing--expanded');
		$menu.hide().slideDown(250, function() { 
			$menu.css('display', ''); 
		});
	}

	e.preventDefault();
}

// Utility function to move related projects to a container based on the specified breakpoint.
function moveRelatedProjects(bp) {
	if (typeof bp === 'undefined') {
		console.log('No destination specified.');
		return;
	}

	var $related         = jQuery('.project__related'),
		destinationClass = 'project__related--' + bp;
		$destination     = jQuery('.' + destinationClass),
		$carousel        = jQuery('.projects-carousel', $related);

	// Check that it's not already a child of the destination container
	if (!$related.parent().hasClass(destinationClass)) {
		$related.appendTo($destination);
		$carousel.flickity('resize');
	}
}

var productTextSearch = debounce(productFilter, 500, true),
	productCategorySearch = debounce(productFilter, 500, false);

// Handle the checkbox dependencies
function productCategoryChange() {

	var $this     = jQuery(this),
		$outer    = $this.closest('.widget__outer'),
		$reset    = jQuery('.widget__reset', $outer),
		$allInput = jQuery('input[value=0], input[value=any]', $outer),
		$inputs   = jQuery('input[type=checkbox]', $outer);

	if ($inputs.length) {

		// This will only run on the two groups of checkboxes
		var $allButAll = $inputs.filter(':not([value=0])'),
			$checked   = $inputs.filter(':checked');

		if ($this.val() != 0) {
			if (!$checked.length) {
				$allInput.prop('checked', true);
			} else if ($checked.length && $checked.length != $allButAll.length) {
				$allInput.prop('checked', false);
			} else if ($checked.length == $allButAll.length) {
				$allInput.prop('checked', true);
				$allButAll.prop('checked', false);
			}
		} else {
			// Clicked item is the All checkbox
			if ($allInput.prop('checked') == true) {
				// If All is checked, uncheck all others
				$allButAll.prop('checked', false);
			} else {
				// Prevent the All checkbox from being unchecked directly
				$allInput.prop('checked', true);
			}
		}
	}

	productShowHideReset();
	productCategorySearch();
}

// Loop through each of the widgets (regardless of context) and 
// determine whether to show or hide their respective reset buttons.
function productShowHideReset() {

	jQuery('.widget__outer').each(function() {
	
		var $outer    = jQuery(this),
			$reset    = jQuery('.widget__reset', $outer),
			$allInput = jQuery('input[value=0], input[value=any]', $outer);
	
		// Show or hide the reset button depending on state
		if ($allInput.prop('checked')) {
			$reset.removeClass('widget__reset--active');
		} else {
			$reset.addClass('widget__reset--active');
		}
	})

}

// Main projects query (ajax)
function productFilter() {
	
	var data             = {},
		nonce            = jQuery('input[name=project_search_nonce]').val(),
		$sidebar         = jQuery('.sidebar--projects'),
		$searchBox       = jQuery('input[name=project_search]', $sidebar),
		searchText       = $searchBox.val(),
		$categoryOuter   = jQuery('.widget_project_categories__outer'),
		$categories      = jQuery('input[type=checkbox]:checked', $categoryOuter).not('[value=0]'),
		$typeOuter       = jQuery('.widget_project_type__outer'),
		$types           = jQuery('input[type=checkbox]:checked', $typeOuter).not('[value=0]'),
		$difficultyOuter = jQuery('.widget_project_difficulty__outer'),
		$difficulty      = jQuery('input[type=radio]:checked', $difficultyOuter);

	data.action = 'afx_products_query';
	data.nonce  = nonce;

	if (searchText.length) {
		data.search = searchText;
	}

	if ($categories.length) {
		var productCategories = $categories.map(function() {
			return jQuery(this).val();
		}).get();
		data.category = productCategories;
	}

	if ($types.length) {
		var productTypes = $types.map(function() {
			return jQuery(this).val();
		}).get();
		data.type = productTypes;
	}

	if ($difficulty.length) {
		var difficulty = $difficulty.val();
		data.difficulty = difficulty;
	}
	
	var $status = jQuery('.project-search-results__status'),
		$container = jQuery('.project-search-results');

	jQuery.ajax({
		type: 'POST',
		url: ajaxurl,
		data: data,
		beforeSend: function() {
			$status.html('Loading results... <span class="fas fa-circle-notch fa-spin"></span>');
		},
		success: function(response) {
			$status.html('<a href="javascript:;" class="btn btn--light project-search-results__reset">Reset search <span class="fas fa-undo-alt"></span></a>');
			$container.html(response.data);
			jQuery('.project-search-results__reset').on('click', resetAllFilters);
		},
		error: function() {
			$status.html('Failed to load results. Please try again. <span class="fas fa-exclamation-triangle"></span>');
		}
	});
}

function productSearchDefault() {

	var data = { action: 'afx_reset_products' },
		$status = jQuery('.project-search-results__status'),
		$container = jQuery('.project-search-results');

	jQuery.ajax({
		type: 'POST',
		url: ajaxurl,
		data: data,
		beforeSend: function() {
			$status.html('Resetting search... <span class="fas fa-circle-notch fa-spin"></span>');
		},
		success: function(response) {
			$status.html('');
			$container.html(response.data);
			var $carousel = jQuery('.project-search__carousel');
			if ($carousel.length) {
				resetProductFlickity();
			}
		},
		error: function() {
			$status.html('Failed to reset results. Please try again. <span class="fas fa-exclamation-triangle"></span>');
		}
	});

}

function resetAllFilters(e) {

	if (typeof e !== 'undefined') {
		e.preventDefault();
	}

	var $sidebar       = jQuery('.sidebar--projects'),
		$allText       = jQuery('input[type=text]', $sidebar),
		$allChecks     = jQuery('input[type=checkbox]', $sidebar),
		$allRadios     = jQuery('input[type=radio]', $sidebar),
		$categoryAll   = jQuery('.project_category_0'),
		$typeAll       = jQuery('.project_type_0'),
		$difficultyAny = jQuery('.project_difficulty_0');

	$allText.val('');
	$allChecks.prop('checked', false);
	$allRadios.prop('checked', false);
	$categoryAll.prop('checked', true);
	$typeAll.prop('checked', true);
	$difficultyAny.prop('checked', true);

	productShowHideReset();
	productSearchDefault();
}

function resetCategoryFilter(e) {
	
	if (typeof e !== 'undefined') {
		e.preventDefault();
	}
	
	var $container     = jQuery('.widget_project_categories__outer'),
		$allChecks     = jQuery('input[type=checkbox]', $container),
		$categoryAll   = jQuery('.project_category_0');

	$allChecks.prop('checked', false);
	$categoryAll.prop('checked', true);

	productShowHideReset();
	productTextSearch();
}

function resetTypeFilter(e) {

	if (typeof e !== 'undefined') {
		e.preventDefault();
	}

	var $container     = jQuery('.widget_project_types__outer'),
		$allChecks     = jQuery('input[type=checkbox]', $container),
		$typeAll       = jQuery('.project_type_0');

	$allChecks.prop('checked', false);
	$typeAll.prop('checked', true);

	productShowHideReset();
	productTextSearch();
}

function resetDifficultyFilter(e) {

	if (typeof e !== 'undefined') {
		e.preventDefault();
	}
	
	jQuery('.project_difficulty_0').prop('checked', true);

	productShowHideReset();
	productTextSearch();
}

function resetProductFlickity() {
	var $carousel = jQuery('.project-search__carousel'),
		breakpoint = jQuery(window).breakpointEvents('setting', 'currentView');
	
	if (breakpoint == 'xs' || breakpoint == 'sm' || breakpoint == 'md') {
		$carousel.flickity({
			cellAlign: 'center',
			imagesLoaded: true,
			pageDots: false,
			wrapAround: true
		});
		flickityLarge = false;
		flickitySmall = true;
	} else {
		$carousel.flickity({
			cellAlign: 'left',
			imagesLoaded: true,
			pageDots: false,
			wrapAround: true
		});
		flickitySmall = false;
		flickityLarge = true;
	}
}